<p-dialog [modal]="true" [(visible)]="showingDetail" (onClose)="closeDetail()">
    <app-group-booking-detail #detailComponent ></app-group-booking-detail>
</p-dialog>

<p-table [value]="groups">
    <ng-template pTemplate="header">
        <tr>
            <th>
                Group ID
            </th>
            <th>
                Group Name
            </th>
            <th>
                School
            </th>
            <th>

            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-group>
        <tr>
            <td>
                {{group.id}}
            </td>
            <td>
                {{group.name}}
            </td>
            <td>
                {{group.schoolName}}
            </td>
            <td>
                <p-button (onClick)="activateDetail(group.id)" label="See details"></p-button>
            </td>
        </tr>
    </ng-template>
</p-table>